<div class="transport-scope" [ngClass]="{'warning': warning}">
  <div class="border" [ngClass]="{'vehicle': fahrzeug}">
    <div class="scope-icon" [ngClass]="scopeClass">
    </div>
  </div>
</div>